import Vue from 'vue'
import Vuex from 'vuex'

import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'

Vue.use(Vuex);

var store = {
    state: {
        _id: false,
        id: false,
        pages: [],
        ads: [],
        terms: '',
        amount: 10,
        response_id: '',
        pay: {
            amount: '10.00'
        },
        offers: [],
        survey: false,
        competitions: false,
        selectedCategory: false,
        TsCs: '',
        user: false,
        auth: false,
        name: '',
        customerNo: '',
        sendSMS: true,
        sendEMAIL: true,
        phone: false,
        loyalty_id: false,
        loyaltyId: false,
        iss: false,
        copper: true,
        clientCampaigns: [],
        host: '',
        client_id: '',
        headerBack: '',
        headerPlain: '',
        backgroundColor: '',
        fontColor: '',
        btnColor: '',
        btnFontColor: '',
        infoFontColor: '',
        title: '',
        siteTitle: '',
        favicon: '',
        memberShipPrice: 0,
        joinPage: '',
        twoele: '',
        loyal1: '',
        loyal2: '',
        welcome: '',
        man: '',
        avatar: false,
        contactUs: '',
        joinWords: '',
        appleFav: '',
        catWords: '',
        adCats: false,
        menu: [],
        selectedCat: true,
        comps: [],
        entries: [],
        loyaltyCampaign_id: false,
        referWords: '',
        terms_id: '',
        referCampaign_id: '',
        referCampaignQty: 0,
        campaign_id: '',
        takeSurvey: [],
        homeBanner: {},
        btnImage: false,
        score: false,
        scores: [],
        //testURL: 'letsreset.club'
        //testURL: 'dev.memberstar.club'
        testURL: 'onegolf.memberstar.club',



        pages: [],
        quills: [],
        pendingWallets: [],
        pendingPages: [],
        client: {},
        session_id: false,
        scale: 1
    },
    actions: {
        addHead ({ state, commit }, data ) {
            if ( document.head.querySelector('#'+data.id) ) return;
            var element = document.createElement(data.t);
                Object.keys(data).filter(k => k != 't').forEach(k => element.setAttribute(k,data[k]));
                document.head.appendChild(element);
        },
        wsAction ({ state, commit, dispatch }, msg ) {
            //console.log('wsAction',msg);
            switch ( msg.t ) {
                case 'noSite':
                    console.log('no-site......');
                    //commit('setPages',['no-site']);
                    break;
                case 'setClient': 
                    var client = msg.data.client;
                    //console.log('setClient client',client);
                    Object.keys(client).forEach(k => {
                        k == '_id' && ( k = 'client_id', client[k] = client._id );
                        commit('setValue',{ k, v: client[k] });
                    });
                    document.querySelector('title').innerText = client.siteTitle;
                    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                    var apple = document.querySelector("link[rel*='apple-touch-icon']") || document.createElement('link');
                    apple.rel = 'apple-touch-icon';
                    apple.sizes = '180x180';
                    //console.log('client.appleFav',client.appleFav);
                    apple.href = client.appleFav;
                    document.querySelector('head').appendChild(apple);
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = client.favicon;
                    document.querySelector('head').appendChild(link);
                    Alert.setColors(client);
                    break;
                case 'setAds':
                    console.log('setAds',msg.data.ads);
                    //commit('setValue',{ k: 'pages', v: ['home','survey' ]});
                    //commit('setValue',{ k: 'ads', v: msg.data.ads });
                    break;
                case 'removeCustomer':
                    commit('clearAuth');
                    break;
                case 'setLoyalty':
                    commit('setAuth',{ _id: msg.data.loyalty_id, id: msg.data.loyaltyId });
                    break;
                    case 'saveLoyalty':
                        commit('setAuth',{ _id: msg.data._id, id: msg.data.id });
                        break;                    
                case 'startSurvey':
                    //commit('setSurvey',msg.data);
                    break;
                case 'updatePhone':
                    commit('setValue',{ k: 'name', v: msg.data.name });
                    commit('setValue',{ k: 'customer_id', v: msg.data.customer_id });
                    commit('setValue',{ k: 'phone', v: msg.data.phone });  
                    break;
                case 'setCustomer':
                    console.log('setCustomer ???',msg.data);
                    debugger;
                    msg.data.name && commit('setValue',{ k: 'name', v: msg.data.name })
                    msg.data.phone && commit('setValue',{ k: 'phone', v: msg.data.phone });
                    msg.data.email && commit('setValue',{ k: 'email', v: msg.data.email });
                    msg.data.customerNo && commit('setValue',{ k: 'customerNo', v: msg.data.customerNo });
                    msg.data.entries && commit('setValue',{ k: 'entries', v: msg.data.entries });
                    msg.data.avatar && commit('setValue',{ k: 'avatar', v: msg.data.avatar });
                    typeof msg.data.sendSMS != 'undefined' && commit('setValue',{ k: 'sendSMS', v: msg.data.sendSMS })
                    typeof msg.data.sendEMAIL != 'undefined' && commit('setValue',{ k: 'sendEMAIL', v: msg.data.sendEMAIL })
                    //console.log('setCustomer setPages',JSON.stringify(state.pages));
                    state.pages.indexOf('home') == -1 && commit('setPages',['home']);
                    dispatch('getScore');
                    break;
                case 'startCustomer':
                    commit('setValue',{ k: 'customerID', v: msg.data.customerID });
                    commit('setValue',{ k: 'customer_id', v: msg.data.customer_id });
                    commit('setValue',{ k: 'iss', v: msg.data.iss });
                    break;
                 case 'copperhouse':
                     var customer = msg.data.customer
                     if ( customer ) {
                         commit('setValue',{ k: 'copper', v: { phone: customer.phone, msisdn: customer.msisdn, name: customer.name, email: customer.email, _id: customer._id }});
                     }   

            }
            //console.log({ loyalty_id: localStorage.loyalty_id, loyaltyId: localStorage.loyaltyId })

        },
        getScore ({ state, commit }) {
            //console.log('action getScore',state.client_id == '5f69cbbb01e0610ab651e146');
            state.client_id == '5f69cbbb01e0610ab651e146' && WebSoc.SEND({ t: 'getScore', data: { client_id: state.client_id, customer_id: state.auth._id, customerId: state.auth.id }},resp => {
                //console.log('getScore',resp);
                typeof resp.score == 'number' && commit('setValue',{ k: 'score', v: resp.score });
            })            
        },
        getScores ({ state, commit }) {
            state.client_id == '5f69cbbb01e0610ab651e146' && WebSoc.SEND({ t: 'getScores', data: { client_id: state.client_id, customer_id: state.auth._id, customerId: state.auth.id }},resp => {
                //console.log('getScores',resp);
                Array.isArray(resp.scores) && commit('setValue',{ k: 'scores', v: resp.scores.reverse() });
            })               
        },
        getSurvey ({ state, commit },data) {
            WebSoc.SEND({ t: 'getSurvey', data },survey => {
                survey && commit('setSurvey',survey);
                location.href = 'http://'+location.host+'/'+data.campaign_id+'/'+data.iss+'/'+data.id;
            });
        },
        getTerms ({ state, commit }, data ) {
            console.log('getTerms data',data);
            if ( state.terms ) return;
            WebSoc.SEND({ t: 'getTsCs' },resp => {
                commit('saveTerms',resp.tscs);
                
            })
        },
        getOffers ({ state, commit }, campaign_id ) {
            console.log('getOffers ??');
            if ( state.offers ) return;
            WebSoc.SEND({ t: 'getOffers', data: { campaign_id } },offers => {
                commit('saveOffers',offers)
            })
        },


        addHead ({ state, commit, dispatch }, data ) {
            //console.log('addHead',data);
            if ( document.head.querySelector('#'+data.id) ) return;
            var element = document.createElement(data.t);
                Object.keys(data).filter(k => ['t','innerHTML'].indexOf(k) == -1).forEach(k => element.setAttribute(k,data[k]));
                data.innerHTML && ( element.innerHTML = data.innerHTML );
                document.head.appendChild(element);
                //console.log(element);
        },
        addFonts ({ state, commit, dispatch }, fontFamilies ) {
            //console.log('fontFamalies',fontFamilies);
            if ( !Array.isArray(fontFamilies) ) return;
            fontFamilies.forEach(family => {
                //console.log('store action addFonts family',JSON.parse(JSON.stringify(family)));
                var fontName = family.font.replace(/ /g,'');
                var href = family.href;

                switch ( family.font ) {
                    case "Poppins":
                        href += ":ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap";
                    break;
                }

                dispatch('addHead',{
                    id: 'link-'+fontName,
                    t: 'link',
                    href,
                    rel: 'stylesheet'                        
                })

                dispatch('addHead',{
                    id: 'style-'+fontName,
                    t: 'style',
                    innerHTML: ".font-"+(family.font.replace(/ /g,'').toLowerCase())+"{font-family:'"+family.font+"'}"
                })
                
            })
        },
        getPending ({ state, commit },btn ) {
            if ( !btn.wallet && !btn.page_id ) return;
            console.log('action getPending',JSON.parse(JSON.stringify(btn)));
            var pendingWallets = state.pendingWallets;
            var pendingPages = state.pendingPages;
            console.log('pendingPage.length',pendingPages.length);
            btn.page_id && !pendingPages.find(p => p._id == btn.page_id) && WebSoc.SEND({ t: 'getPage', data: { page_id: btn.page_id, client_id: state.client_id } },data => commit('addPending',{ page: data.page }));
            btn.wallet_id && !pendingWallets.find(wallet => wallet._id == btn.page_id) && WebSoc.SEND({ t: 'getWallet', data: { wallet_id: btn.wallet_id, client_id: state.client_id } },data => commit('addPending',{ wallet: data.wallet }));
        },
        pushPage ({ state, commit }, page_id  ){
            console.log('pushPage',page_id);
            var page = state.pendingPages.find(p => p._id == page_id);
            console.log('fromPending pushPage',page && page.title)
            if ( page ) return commit('pushPage',page);
            WebSoc.SEND('get',{ DB: 'pages', _id: page_id },page => {
                console.log('added to Pending pushPage',page && page.title)
                commit('addPending',{ page });
                commit('pushPage',page);
            })
        },
        initWS ({ state, commit, dispatch }, $route ) {
            //console.log('store initWS',$route);
            var timer = 0, interval = 50;

            if ( window.webpackHotUpdate ) {
                var URL = 'ws://localhost:5555'   
                //var URL = 'wss://api-v2.dev.memberstar.club'
                var host = state.testURL;
            } else {
                if ( location.host.startsWith('dev.memberstar') ) {
                    var URL = 'wss://api-v2.dev.memberstar.club'
                } else {
                    //var URL = 'wss://api-v2.memberstar.club';
                    var URL = 'wss://api-v2.dev.memberstar.club'
                }
                var host = window.location.host;
            }     
            
            try {
                var customer_id = localStorage.customer_id;
                var customerId = localStorage.customerID;
            } catch(e) {

            }

            var path = encodeURIComponent($route.path);
            var query = encodeURIComponent(JSON.stringify($route.query));
            if ( customer_id && customerId ) {
                URL += '/ms-v2/app/customer/'+host+'/'+customer_id+'/'+customerId;
            } else {
                URL += '/ms-v2/app/new-customer/'+host+'/';
            }

            if ( state.session_id ) {
                query += '&session_id='+state.session_id;
            }

            //console.log('query...','?path='+path+'&query='+query);
            var now = Date.now();
            WebSoc(URL+'?path='+path+'&query='+query,{
                onclose () {
                    setTimeout(() => {
                        dispatch('initWS',$route);
                    },500)
                },
                onopen ( ws ) {
                    //console.log('open',Date.now() - now);
                },
                onmessage ( msg ) {
                    
                    //console.log('onmessage',Date.now() - now,msg);

                    var Service = {
                        setClient ( data ) {
                            //console.log('setClient',data);
                            commit('setClient',data.client);
                        },
                        setCustomer ( data ) {
                            console.log('setCustomer',data);
                        },
                        setSession_id ( data ) {
                            commit('setSession_id',data);
                        },
                        setHome ( data ) {
                            console.log('setHome',data);
                        },
                        setPages ( data ) {
                            commit('setPages',data.pages);
                            //console.log('setPages',data)
                        },
                        setCards ( data ) {
                            console.log('setCards',data)
                        }
                    }

                    Service[msg.t] ? Service[msg.t](msg.data) : console.log('onmessage no Service',msg);
                } 
            })

        },
        getQuillSlide ({ state, commit, dispatch }, quill_id ) {
            if ( !quill_id ) return;
            var quill = state.quills.find(q => q._id == quill_id);
            if ( quill ) return dispatch('showQuill',quill);
            WebSoc.SEND({ t: 'getCQuill', data: { quill_id, client_id: state.client_id }},quill => {
                dispatch('showQuill',quill);
                commit('saveQuill',quill);
            });            
        },
        showQuill ({ state, commit }, quill ) {
            var div = document.createElement('div');
                div.innerHTML = `<div class="quill-box off-bottom"><div class="x"></div><div class="ql-editor"></div></div>`;
                
            var vc = document.querySelector('.view-container');
            var Qb = div.querySelector('.quill-box');
            var QLe = Qb.querySelector('.ql-editor');
                QLe.innerHTML = quill.html;
            var QBx = Qb.querySelector('.x');     

                vc.appendChild(Qb);

                return setTimeout(() => {
                    Qb.classList.add('show');
                    QBx.onclick = () => {
                        Qb.classList.remove('show');
                        setTimeout(() => {
                            vc.removeChild(Qb);
                        },400)
                    }
                },50)

            var QLe = this.$el.querySelector('.ql-editor');
            var Qb = this.$el.querySelector('.quill-box');
            var QBx = Qb.querySelector('.x');
            QLe.innerHTML = quill.html;
            Qb.classList.remove('dn');
            setTimeout(() => {
                Qb.classList.add('show');
                QBx.onclick = () => {
                    Qb.classList.remove('show');
                    setTimeout(() => {
                        Qb.classList.add('dn');
                    },400)
                }
            },50)
        },
    },
    mutations: {
        addPending ( state, data ) {
            console.log('mutations addPending',data);
            data.wallet && state.pendingWallets.push(data.wallet)
            data.page && state.pendingPages.push(data.page)
        },
        setClient ( state, client ) {
            state.client = client;
            state.client_id = client._id;
            //console.log('state.client_id',state.client_id);
            //console.log('client',JSON.stringify(client,null,1));
        },

        pushPage ( state, page ) {
            state.pages.push(page);
        },

        popPage ( state, page ) {
            setTimeout(() => {
                state.pages.pop();
            },400);
        },

        setPages ( state, pages ) {
            //console.log('mutations setpages',pages);
            state.pages = pages;
        },

        setSession_id ( state, data ) {
            state.session_id = data.session_id;
        },

        clearAuth ( state ) {
            state.entries = [];
            state.comps = [];
            state.ads = [];
            state.offers = [];
            state.auth = false;
            state.loyalty_id = false;
            state.loyaltyId = false;
            state.pages = ['home','copper'];
            state.name = '';
            state.customerNo = '';
            try {
                localStorage.clear();
            } catch(e) {

            }
        },
        setValue ( state, { k, v }) {
            //console.log('setValue',{ k, v });
            state[k] = v;
        },
        setKeyValue ( state, { item, k, v }) {
            item[k] = v;
        },
        setItemKeyValue ( state,{ item, k, v }) {
            item[k] = v;
        },
        addEntry ( state, entry ) {
            entry.entered = true;
            state.entries.push(entry);
        },
        setAuth ( state, auth ) {
            //console.log('setAuth',auth);
            state.auth = auth;
            if ( !auth ) return;
            //console.log('setAuth auth._id',auth._id);
            //console.log('setAuth auth.id',auth.id);
            try {
                state._id = auth._id;
                state.id = auth.id;
                localStorage.loyalty_id = auth._id;
                localStorage.loyaltyId = auth.id;
            } catch(e) {

            }
            //setInterval(() => console.log({ loyalty_id: localStorage.loyalty_id, loyaltyId: localStorage.loyaltyId }),1000);
            store.mutations.setValue(state,{ k: 'auth', v: auth })
            auth.name && ( state.name = auth.name );
            auth.phone && ( state.phone = auth.phone );
            auth.email && ( state.email = auth.email );
        },
        setSurvey ( state, survey ) {
            survey.pages.forEach(p => p.date = Date.now());
            state.ads = survey.pages;
            console.log('setSurvey');
            state.pages = ['home','survey'];
        },
        setCompetitions ( state, competitions ) {

        },
        saveTerms ( state, terms ) {
            state.terms = terms;
        },
        saveOffers ( state, offers ) {
            console.log('saveOffers')
            state.offers = offers;
        },
        /*
        setPages ( state, pages ) {
            state.pages = pages;
        },
        */
       /*
        pushPage ( state, page ) {
            return console.log('pushPage',page);

            if ( !page ) return;
            state.pages.indexOf(page) == -1 && state.pages.push(page);
        },
        */

        saveQuill ( state, quill ) {
            console.log('saveQuill',quill);
            state.quills.push(quill);
        },
        popPage ( state, page ) {           
            setTimeout(() => {
                if ( page ) { var indexPage = state.pages.indexOf(page) }
                if ( page && indexPage == -1 ) return;
                if ( !page ) return console.log('must specify popPage')
                state.pages.splice(indexPage,1);
            },500)
        }
    }
}

export default new Vuex.Store(store);